import { render, staticRenderFns } from "./ActivityConfirmButton.vue?vue&type=template&id=2ddb5e21&scoped=true"
import script from "./ActivityConfirmButton.vue?vue&type=script&lang=ts"
export * from "./ActivityConfirmButton.vue?vue&type=script&lang=ts"
import style0 from "./ActivityConfirmButton.vue?vue&type=style&index=0&id=2ddb5e21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddb5e21",
  null
  
)

/* custom blocks */
import block0 from "./ActivityConfirmButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports